// extracted by mini-css-extract-plugin
module.exports = {"tile":"HomeCreditsSection_tile__3PHD7"};